import React from 'react'
import PropTypes from 'prop-types'

const getValidadoPresentation = (value) => {
    const validados = {
        1 : "Validado",
        2 : "Rechazado",
        0 : "No Validado",
        3 : "En Uso",
    }
    return validados[value] || ""
}

const ValidadoField = ({ source, record = {} }) => <span>{getValidadoPresentation(record[source])}</span>

ValidadoField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
}

export default ValidadoField